"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactTagOptions = void 0;
var ArtifactTagOptions;
exports.ArtifactTagOptions = ArtifactTagOptions;
(function (ArtifactTagOptions) {
  ArtifactTagOptions["PRODUCTION"] = "production";
  ArtifactTagOptions["NONPRODUCTION"] = "nonproduction";
  ArtifactTagOptions["UNASSIGN"] = "unassign";
})(ArtifactTagOptions || (exports.ArtifactTagOptions = ArtifactTagOptions = {}));